<template>
  <div class="main">
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x2">
        <div class="col d-flex justify-content-between align-items-center">
          <h2>CMS Entries</h2>
          <router-link to="/cms/create" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline">
            <i class="fas fa-plus mr-x1"></i>Add an Entry
          </router-link>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col">
          <div class="row mb-x4">
            <div class="col">
              <table class="zero-table">
                <tr>
                  <th>Title</th>
                  <th>Blurb One</th>
                  <th>Example File</th>
                  <th></th>
                </tr>
                <tr v-for="(item, index) in cmsArray" :key="index">
                  <td>{{ item.title }}</td>
                  <td>{{ item.blurb_one }}</td>
                  <td>{{ item.example_file }}</td>
                  <td>
                    <router-link :to="'/cms/' + item.id" class="">
                      Details
                    </router-link>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const localApiURL = 'http://localhost:8000/api/cms'
// const remoteApiURL = 'https://timothyreeder.com/alpha/zero-api/public/api/cms'

const apiChoice = localApiURL

export default {
  name: 'cmsadmin',
  components: {
    Nav
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      cmsArray: []
    }
  },
  created () {
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
      this.getAllCMS()
    }
  },
  methods: {
    getAllCMS () {
      this.isLoading = true
      axios
        .get(apiChoice + '', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // transfer the response
          this.cmsArray = response.data
        })
        .catch((error) => {
          console.log(error.response.data)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
